api = require '../api'

module.exports =
  find: (id) ->
    api.send
      method: 'GET'
      path: "/api/v2/applications/#{id}"
